import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnInit, inject, input } from "@angular/core";
import { ColorEnum } from "../../core-ui.enums";

@Component({
  selector: "app-pointer",
  templateUrl: "./pointer.component.html",
  styleUrls: ["./pointer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PointerComponent implements OnInit {
  private host = inject<ElementRef<HTMLDivElement>>(ElementRef);

  readonly sender = input<string>(undefined);
  readonly color = input<ColorEnum.blue | ColorEnum.green>(undefined);

  @HostBinding("class") get class() {
    const color = this.color();
    return {
      "av-pointer-blue": color === ColorEnum.blue || !color,
      "av-pointer-green": this.color() === ColorEnum.green,
    };
  }

  ngOnInit(): void {}

  get nativeElement(): HTMLDivElement {
    return this.host.nativeElement;
  }

  // @HostBinding('style')
  // get style() {
  //   return {
  //     left: this.left + 'px',
  //     top: this.top + 'px'
  //   };
  // }
}
